export const GET_VENUE= 'GET_VENUE'
export const GET_VENUE_SUCCESS= 'GET_VENUE_SUCCESS'
export const GET_VENUE_ERROR='GET_VENUE_ERROR'

export const GetVenue= (data) => ({
    type: GET_VENUE,
    payload: data
})


